import api from "@/plugins/axios";
import Setting from "@/models/setting";

const SettingsAPI = {
  async getSettings(): Promise<Setting> {
    return api.get("/settings");
  },
  async updateSettings(payload: Setting): Promise<Setting | undefined> {
    return api.put("/settings", payload);
  },
};

export default SettingsAPI;
